<svelte:options
  customElement={{
    tag: "oc-badge-v2",
    /*                                            */
    extend: window.__components.extend(),
    props: {
      size: { type: "String" },
      variant: { type: "String" },
      icon: { type: "String" },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./BadgeV2.types.js";
  import DefaultStyles from "../../../common/components/DefaultStyles/DefaultStyles.svelte";

  let { variant = "primary", size = "100", icon }: Props = $props();
</script>

<div
  class="badge {`badge--type-${variant}`} {`badge--size-${size}`}"
  class:badge--with-icon={!!icon}
>
  {#if size === "100"}
    {#if icon && size === "100"}
      <oc-icon-v1 size={/*                      */ "50"} type={icon}></oc-icon-v1>
    {:else}
      <slot />
    {/if}
  {/if}
</div>

<DefaultStyles />

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";
  :global {
    :host {
      display: inline-block;
      vertical-align: top; /*                                                                                 */
    }

    .badge {
      height: tokens.$oc-component-badge-100-height;
      color: tokens.$oc-component-badge-100-text-color;
      font: tokens.$oc-component-badge-100-font;
      text-align: center;
      line-height: tokens.$oc-component-badge-100-height;
      outline: tokens.$oc-component-badge-border-color solid tokens.$oc-component-badge-border-width;
      border-radius: tokens.$oc-component-badge-100-border-radius;
      padding: 0 4px;

      &--with-icon {
        display: flex;
        align-items: center;
        padding: 0 2px;

        oc-icon-v2 {
          height: 1rem;
        }
      }

      &--type-primary {
        background-color: tokens.$oc-component-badge-primary-background-color-text;

        &.badge--with-icon {
          background-color: tokens.$oc-component-badge-primary-background-color;
        }
      }
      &--type-secondary {
        background-color: tokens.$oc-component-badge-secondary-background-color-text;

        &.badge--with-icon {
          background-color: tokens.$oc-component-badge-secondary-background-color;
        }
      }
      &--type-success {
        background-color: tokens.$oc-component-badge-success-background-color-text;

        &.badge--with-icon {
          background-color: tokens.$oc-component-badge-success-background-color;
        }
      }

      &--type-warning {
        background-color: tokens.$oc-component-badge-warning-background-color-text;

        &.badge--with-icon {
          background-color: tokens.$oc-component-badge-warning-background-color;
        }
      }

      &--type-error {
        background-color: tokens.$oc-component-badge-error-background-color-text;

        &.badge--with-icon {
          background-color: tokens.$oc-component-badge-error-background-color;
        }
      }

      &--type-hint {
        background-color: tokens.$oc-component-badge-hint-background-color-text;

        &.badge--with-icon {
          background-color: tokens.$oc-component-badge-hint-background-color;
        }
      }

      &--size-100 {
        min-width: tokens.$oc-component-badge-100-min-width;
      }

      &--size-50 {
        height: tokens.$oc-component-badge-50-height;
        width: tokens.$oc-component-badge-50-height;
        border-radius: 50%;
        background-color: tokens.$oc-component-badge-primary-background-color;
      }
    }
  }
</style>
